import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-bold-down-red",
  "use": "app-icon-arrow-bold-down-red-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 6\" id=\"app-icon-arrow-bold-down-red\"><path d=\"M4 5.818L0 0h8z\" fill=\"#FF4C4C\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol